/**
 * VIDEO モジュール
 * - メインビジュアルに、画面幅に応じてPC/SPの動画を埋め込む
 */
export const VIDEO = {
  init() {
    const container = document.querySelector('.js-video')
    if (!container) return

    const isMobile = window.innerWidth < 768

    // <video> 要素を作成
    const video = document.createElement('video')
    video.autoplay = true
    video.muted = true
    video.loop = true
    video.playsInline = true
    video.className = 'c-video'
    video.poster = isMobile
      ? '/wp-content/themes/mybest-ohtawara/assets/img/top/kv01_sp.webp'
      : '/wp-content/themes/mybest-ohtawara/assets/img/top/kv01_pc.webp'

    // <source> 要素を作成し、デバイス別に動画を切り替え
    const source = document.createElement('source')
    source.src = isMobile
      ? '/wp-content/themes/mybest-ohtawara/assets/img/top/kv01_sp.mp4'
      : '/wp-content/themes/mybest-ohtawara/assets/img/top/kv01_pc.mp4'
    source.type = 'video/mp4'

    // 構成してDOMへ追加
    video.appendChild(source)
    container.appendChild(video)
  },
}
